// BarnabasPress artists front-end JS

function createCyclerSlot() {
	const link = document.createElement("a");
	link.className = "group block";

	const frame = document.createElement("div");
	frame.className = "relative aspect-[4/3] overflow-hidden border border-slate-200 bg-slate-100";

	const imgA = document.createElement("img");
	imgA.className = "absolute inset-0 h-full w-full object-cover opacity-100 transition-opacity duration-700 ease-in-out";
	// imgA.loading = "lazy";

	const imgB = document.createElement("img");
	imgB.className = "absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 ease-in-out";
	// imgB.loading = "lazy";

	frame.append(imgA, imgB);

	link.append(frame);

	return {
		link,
		frame,
		layers: [imgA, imgB],
		activeLayerIndex: 0,
		currentWorkId: null,
		currentImageSrc: null,
	};
}

function setSlotContent(slot, item) {
	const activeLayer = slot.layers[slot.activeLayerIndex];
	activeLayer.src = item.imageSrc;
	activeLayer.alt = item.title || "Artwork image";
	activeLayer.classList.remove("opacity-0");
	activeLayer.classList.add("opacity-100");
	slot.link.href = item.artistUrl;
	slot.currentWorkId = item.workId;
	slot.currentImageSrc = item.imageSrc;
}

function crossFadeTo(slot, item) {
	const hiddenLayerIndex = slot.activeLayerIndex === 0 ? 1 : 0;
	const activeLayer = slot.layers[slot.activeLayerIndex];
	const hiddenLayer = slot.layers[hiddenLayerIndex];

	hiddenLayer.src = item.imageSrc;
	hiddenLayer.alt = item.title || "Artwork image";
	slot.link.href = item.artistUrl;

	hiddenLayer.classList.remove("opacity-0");
	hiddenLayer.classList.add("opacity-100");
	activeLayer.classList.remove("opacity-100");
	activeLayer.classList.add("opacity-0");

	slot.activeLayerIndex = hiddenLayerIndex;
	slot.currentWorkId = item.workId;
	slot.currentImageSrc = item.imageSrc;
}

function getDisplayedImageSrcSet(slots) {
	return new Set(slots.map((slot) => slot.currentImageSrc).filter(Boolean));
}

function initImageCycler() {
	const container = document.getElementById("image-cycler");
	const source = document.getElementById("image-cycler-source");
	if (!container || !source) return;

	const sourceNodes = Array.from(source.querySelectorAll("[data-work-id]"));
	for (let i = sourceNodes.length - 1; i > 0; i -= 1) {
		const randomIndex = Math.floor(Math.random() * (i + 1));
		[sourceNodes[i], sourceNodes[randomIndex]] = [sourceNodes[randomIndex], sourceNodes[i]];
	}

	sourceNodes.forEach((node) => {
		source.appendChild(node);
	});

	const allItems = sourceNodes
		.map((node) => ({
			workId: node.getAttribute("data-work-id") || "",
			artistUrl: node.getAttribute("data-artist-url") || "",
			imageSrc: node.getAttribute("data-image-src") || "",
			title: node.getAttribute("data-title") || "Untitled",
		}))
		.filter((item) => item.workId && item.artistUrl && item.imageSrc);

	if (allItems.length === 0) return;

	const slotCount = Number(container.getAttribute("data-slot-count") || 3);
	const slotsToRender = Math.min(slotCount, allItems.length);
	const slots = [];
	const usedImageSrcs = new Set();

	for (let i = 0; i < allItems.length && slots.length < slotsToRender; i += 1) {
		const item = allItems[i];
		if (usedImageSrcs.has(item.imageSrc)) {
			continue;
		}

		const slot = createCyclerSlot();
		setSlotContent(slot, item);
		container.appendChild(slot.link);
		slots.push(slot);
		usedImageSrcs.add(item.imageSrc);
	}

	if (allItems.length <= slotsToRender) return;

	let lastCycledSlotIndex = -1;

	window.setInterval(() => {
		const selectableIndices = slots
			.map((_slot, index) => index)
			.filter((index) => slots.length <= 1 || index !== lastCycledSlotIndex);
		if (selectableIndices.length === 0) return;

		const nextSlotIndex = selectableIndices[Math.floor(Math.random() * selectableIndices.length)];
		const slot = slots[nextSlotIndex];
		if (!slot) return;
		lastCycledSlotIndex = nextSlotIndex;

		const displayedImageSrcs = getDisplayedImageSrcSet(slots);

		const candidates = allItems.filter(
			(item) => item.workId !== slot.currentWorkId && !displayedImageSrcs.has(item.imageSrc)
		);
		if (candidates.length === 0) return;

		const next = candidates[Math.floor(Math.random() * candidates.length)];
		if (next.workId === slot.currentWorkId) return;
		crossFadeTo(slot, next);
	}, 5000);
}

function hydrateMailtoHref(element) {
	if (!element) return;
	const source = element.getAttribute("data-mailto");
	if (!source) return;

	const href = source.replaceAll("~AT~", "@");
	element.setAttribute("href", href);
}

function initMailtoHydration() {
	const mailtoElements = document.querySelectorAll("[data-mailto]");
	if (!mailtoElements.length) return;

	mailtoElements.forEach((element) => {
		element.addEventListener("mouseover", () => {
			hydrateMailtoHref(element);
		});

		element.addEventListener("click", () => {
			hydrateMailtoHref(element);
		});
	});
}

function initPageVisitTracking() {
	const storageKey = "pageVisitState";
	const currentPage = {
		path: window.location.pathname,
		title: document.title || "",
	};

	let previousPage = null;

	try {
		const raw = sessionStorage.getItem(storageKey);
		if (raw) {
			const parsed = JSON.parse(raw);
			if (parsed && typeof parsed === "object" && parsed.is) {
				previousPage = parsed.is;
			}
		}
	} catch (_error) {
		// Ignore parse/storage errors so page behavior is not affected.
	}

	const state = {
		was: previousPage,
		is: currentPage,
	};

	try {
		sessionStorage.setItem(storageKey, JSON.stringify(state));
	} catch (_error) {
		// Ignore storage errors so page behavior is not affected.
	}
}

function initBackLinkUpdates() {
	const backLinks = document.querySelectorAll("a[data-update-back-link]");
	if (!backLinks.length) return;
	const currentPath = window.location.pathname;

	let previousPage = null;

	try {
		const raw = sessionStorage.getItem("pageVisitState");
		if (raw) {
			const parsed = JSON.parse(raw);
			const was = parsed && typeof parsed === "object" ? parsed.was : null;
			if (
				was &&
				typeof was === "object" &&
				typeof was.path === "string" &&
				was.path.startsWith("/") &&
				typeof was.title === "string"
			) {
				previousPage = was;
			}
		}
	} catch (_error) {
		// Ignore parse/storage errors so page behavior is not affected.
	}

	if (!previousPage) return;

	let previousPathname = previousPage.path;

	try {
		previousPathname = new URL(previousPage.path, window.location.origin).pathname;
	} catch (_error) {
		// Ignore invalid URL parsing and fall back to raw path comparison.
	}

	if (previousPathname === currentPath) return;

	backLinks.forEach((link) => {
		link.setAttribute("href", previousPage.path);
		link.textContent = previousPage.title || previousPage.path;
	});
}

function initZoomableImages() {
	const zoomableImages = document.querySelectorAll("img[data-zoomable]");
	if (!zoomableImages.length) return;

	let modal = document.getElementById("image-zoom-modal");
	let modalImage = modal ? modal.querySelector("img") : null;

	if (!modal || !modalImage) {
		modal = document.createElement("div");
		modal.id = "image-zoom-modal";
		modal.style.position = "fixed";
		modal.style.inset = "0";
		modal.style.background = "rgba(15, 23, 42, 0.7)";
		modal.style.display = "none";
		modal.style.alignItems = "center";
		modal.style.justifyContent = "center";
		modal.style.zIndex = "9999";
		modal.style.cursor = "zoom-out";

		modalImage = document.createElement("img");
		modalImage.style.maxWidth = "95vw";
		modalImage.style.maxHeight = "95vh";
		modalImage.style.objectFit = "contain";

		modal.appendChild(modalImage);
		document.body.appendChild(modal);

		modal.addEventListener("click", () => {
			modal.style.display = "none";
			modalImage.removeAttribute("src");
			modalImage.removeAttribute("alt");
		});
	}

	zoomableImages.forEach((image) => {
		if (image.dataset.zoomableBound === "true") return;
		image.dataset.zoomableBound = "true";
		image.style.cursor = "zoom-in";

		image.addEventListener("click", (event) => {
			event.preventDefault();
			event.stopPropagation();

			const source = image.currentSrc || image.getAttribute("src");
			if (!source) return;

			modalImage.src = source;
			modalImage.alt = image.getAttribute("alt") || "";
			modal.style.display = "flex";
		});
	});
}

function onPageLoad() {
	initPageVisitTracking();
	initBackLinkUpdates();
	initZoomableImages();
}

initImageCycler();
initMailtoHydration();
window.addEventListener("load", onPageLoad);